import { BrandMediaFile, LogoVariant } from 'types'
import { MissingLogo } from './MissingLogo'
import { DeleteButton } from './DeleteButton'
import { ReplaceButton } from './ReplaceButton'
import cx from 'classnames'
import Styles from './Logos.module.scss'
import { LoadingEllipses } from 'components/Wizards/Wizard/Form/SectionHeader'

interface LogoProps {
  logo: BrandMediaFile | undefined
  variant: LogoVariant
  onDelete: (logo: BrandMediaFile) => void
  onReplace: (variant: LogoVariant, file: File) => void
  onRegenerate?: () => void
  isGenerating?: boolean
  isDisabled: boolean
}

export const Logo = ({ logo, variant, onDelete, onReplace, isDisabled, onRegenerate, isGenerating }: LogoProps) => {
  if (isGenerating && variant !== LogoVariant.Original) {
    return (
      <div className={Styles.logo}>
        <LoadingEllipses />
      </div>
    )
  }

  if (!logo) {
    return (
      <div className={cx(Styles.logo, Styles.missingLogo)}>
        <MissingLogo onUpload={(file) => onReplace(variant, file)} onRegenerate={onRegenerate} />
      </div>
    )
  }

  return (
    <div className={cx(Styles.logo, { [Styles.light]: variant === LogoVariant.Light })} data-testid={`logo-${variant}`}>
      <div className={Styles.logoActions}>
        <DeleteButton onDelete={() => onDelete(logo)} isDisabled={isDisabled} />
        <ReplaceButton onReplace={(file) => onReplace(variant, file)} isDisabled={isDisabled} />
      </div>
      <img src={logo.media_file.source_url} alt="" />
    </div>
  )
}
